import script from "./AddGrantModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddGrantModal.vue?vue&type=script&setup=true&lang=js"

import "./AddGrantModal.vue?vue&type=style&index=0&id=3360dff8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3360dff8"]])

export default __exports__